import Layout from '@/app/ui/layout/index.vue';
import { FlagsPermissionPusatResolusiV2 } from '@/feature-flags/flags-pusat-resolusi-v2';
import PusatResolusiV2 from '@/app/ui/views/pusat-resolusi-v2/index.vue';
import PusatResolusiDetailKendala from '@/app/ui/views/pusat-resolusi-v2/detail/index.vue';
import Create from "@/app/ui/views/pusat-resolusi-v2/components/create-v2.vue";

export default [
  {
    path: "/pusat-resolusi-v2",
    component: Layout,
    name: "pusat-resolusi-v2",
    redirect: "/dashboard",
    meta: {
      icon: "user-management",
      children: false,
      header: true,
      title: "Pusat Resolusi",
      name: "Pusat Resolusi",
      permission: FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_enable,
      maskedPath: "resolution-center-v2"
    },
    children: [
      {
        path: "",
        name: "pusat-resolusi-v2-list",
        component: PusatResolusiV2,
        redirect: "/pusat-resolusi-v2/tiket-eskalasi",
        meta: {
          header: true,
          isAuth: true
        },
        children: [
          {
            path: "tiket-eskalasi",
            name: "ticket_escalate",
            component: PusatResolusiV2,
            meta: {
              tab: "ticket_escalate",
              permission:  FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_enable,
            }
          },
          {
            path: "tiket-saya",
            name: "my_ticket",
            component: PusatResolusiV2,
            meta: {
              tab: "my_ticket",
              permission: FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_enable,
            }
          },
          {
            path: "tiket-diikuti",
            name: "ticket_followed",
            component: PusatResolusiV2,
            meta: {
              tab: "ticket_followed",
              permission: FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_enable,
            }
          }
        ]
      }
    ]
  },
  {
    path: "/pusat-resolusi-v2",
    component: Layout,
    name: "pusat-resolusi-v2-detail-layout",
    meta: {
      title: "Pusat Resolusi | Detail",
      hidden: false,
      parent: "Pusat Resolusi",
      permission: FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_view_detail_kendala,
      maskedPath: "resolution-center-v2",
      layoutNoPadding: true,
    },
    children: [
      {
        path: "detail/:id",
        name: "pusat-resolusi-v2-detail",
        component: PusatResolusiDetailKendala,
        meta: {
          header: false,
        }
      }
    ]
  },
  {
    path: "/pusat-resolusi-v2",
    component: Layout,
    name: "pusat-resolusi-v2-create-layout",
    meta: {
      icon: "route",
      children: false,
      hidden: true,
      parent: "Pusat Resolusi",
      permission: FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_buat_kendala,
      maskedPath: "resolution-center-v2"
    },
    children: [
      {
        path: "create",
        name: "pusat-resolusi-v2-create",
        component: Create,
        meta: {
          title: "Pusat Resolusi | Create",
          name: "pusatResolusi.laporkanKendala",
          before: "/pusat-resolusi-v2",
          layoutNoPadding: true
        }
      }
    ]
  },
  {
    path: "/pusat-resolusi-v2",
    component: Layout,
    name: "pusat-resolusi-v2-list-layout",
    meta: {
      icon: "route",
      children: true,
      hidden: true,
      permission: FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_enable,
      maskedPath: "resolution-center-v2"
    },
    children: [
      {
        path: "list",
        name: "pusat-resolusi-v2-list-ticket",
        component: PusatResolusiV2,
        meta: {
          title: "Pusat Resolusi | List",
          name: "Pusat Resolusi",
          before: "/pusat-resolusi-v2",
          layoutNoPadding: true
        }
      }
    ]
  }
];
